<template>
  <div class="memberintroduce">
    <Nav></Nav>
    <div class="memberintroduce-box">
      <div class="memberintroduce-inner">
        <div class="banner-box">
          <div class="banner-text">开启独自开 开始轻创业</div>
          <div class="banner-sub-text">
            你不是一个人在奋斗，<br />独自开团队与你一起面对未知的困难
          </div>
        </div>
        <div class="introduce-items-box">
          <div class="introduce-item-box">
            <img class="introduce-item-icon" src="@/assets/icon_free.png" />
            <div class="introducemain-box">
              <div class="introduce-name">体验版</div>
              <div class="introduce-price">
                <!-- <span class="price-cont">¥0</span>元/月 -->
                <span class="price-cont"></span>
              </div>
              <div class="button-box">
                <!-- <el-button
                  class="custom-button btn-border btn-regnow"
                  @click="handleToRegister"
                  >立即认证</el-button
                > -->
                <el-button
                  class="custom-button btn-border btn-regnow"
                  @click="copyLink"
                  >立即认证</el-button
                >
              </div>
              <div :class="['devsource-title-box']">
                <img class="icon_exploit" src="@/assets/icon_exploit.png" />
                <div>开发资源</div>
              </div>
              <div class="source-items-box">
                <div class="source-item-box pt-25">
                  <div class="label">参与项目开发</div>
                  <img class="icon-forbid" src="@/assets/icon_forbid.png" />
                </div>                    
                <div class="source-item-box">
                  <div class="label">白名单数量</div>
                  <div class="count">1个</div>
                </div>
                <div class="source-item-box">
                  <div class="label">案例库权限</div>
                  <div class="count">1个</div>
                </div>
                <div class="source-item-box pt-25">
                  <div class="label">开发环境</div>
                  <img class="icon-forbid" src="@/assets/icon_forbid.png" />
                </div>
                <!-- <div class="source-item-box pt-25">
                  <div class="label">发布服务器权限</div>
                  <img class="icon-forbid" src="@/assets/icon_forbid.png" />
                </div>
                <div class="source-item-box pt-25">
                  <div class="label">发布项目权限</div>
                  <img class="icon-forbid" src="@/assets/icon_forbid.png" />
                </div> -->
                <div class="source-item-box pt-25">
                  <div class="label">商务支持</div>
                  <img class="icon-forbid" src="@/assets/icon_forbid.png" />
                </div>
                <div class="source-item-box pt-25">
                  <div class="label">技术支持</div>
                  <img class="icon-forbid" src="@/assets/icon_forbid.png" />
                </div>
                <div class="source-item-box pt-25">
                  <div class="label">Ui支持</div>
                  <img class="icon-forbid" src="@/assets/icon_forbid.png" />
                </div>
              </div>
              <div class="productsource-title-box">
                <img class="icon_exploit" src="@/assets/icon_product.png" />
                <div>产品资源</div>
              </div>
              <div class="source-items-box source-items-box-product">
                <div class="source-item-box">
                  <div class="label">独自开开发工具包下载次数</div>
                  <div class="count">不限</div>
                </div>
              </div>
            </div>
          </div>
          <div class="introduce-item-box professional">
            <img class="introduce-item-icon" src="@/assets/icon_vip.png" />
            <!-- <div
              v-if="userInfo && userInfo.user_remark_012 !== '1202'"
              class="first-year-box"
            >
              <div>首年打一折</div>
                           <el-tooltip
                placement="bottom"
                :enterable="true"
                popper-class="custom-tooltip"
              >
                <div slot="content" class="custom-tooltip-inner">
                  首发项目：1024元/个；<br />第二个项目：819.2元/个；<br />第三个项目及以上：614.4元/个。
                </div>
                <div class="remind-icon-box">
                  <img class="remind-icon" src="@/assets/icon_remind.png" />
                </div>
              </el-tooltip>
            </div> -->
            <div class="introducemain-box">
              <div class="introduce-name">专业版</div>
              <div class="introduce-price">
                <!-- <span class="price-cont">¥{{ price.toFixed(2) }}</span
                >元/月 -->
                <span class="price-cont"></span>
              </div>
              <div class="button-box">
                <!-- <el-button
                  class="custom-button btn-ff3333 btn-upgrade"
                  @click="handleUpgrade"
                  >{{
                    userInfo &&
                    userInfo.user_remark_018 &&
                    userInfo.user_remark_018 === "1802"
                      ? "认证开发者，具备接单资格"
                      : "立即认证，获得接单资格"
                  }}</el-button
                > -->
                <el-button
                  class="custom-button btn-ff3333 btn-upgrade"
                  @click="copyLink"
                  >{{
                    userInfo &&
                    userInfo.user_remark_018 &&
                    userInfo.user_remark_018 === "1802"
                      ? "认证开发者，具备接单资格"
                      : "立即认证，获得接单资格"
                  }}</el-button
                >
              </div>
              <div class="devsource-title-box">
                <img
                  class="icon_exploit"
                  src="@/assets/icon_exploit_white.png"
                />
                <div>开发资源</div>
              </div>
              <div class="source-items-box">
                <div class="source-item-box pt-25">
                  <div class="label">参与项目开发</div>
                  <img class="icon-forbid" src="@/assets/icon_allowed.png" />
                </div>   
                <div class="source-item-box">
                  <div class="label">白名单数量</div>
                  <div class="count">10个</div>
                </div>
                <div class="source-item-box">
                  <div class="label">案例库权限</div>
                  <div class="count">不限</div>
                </div>
                <div class="source-item-box pt-25">
                  <div class="label">开发环境</div>
                  <img class="icon-forbid" src="@/assets/icon_allowed.png" />
                </div>
                <!-- <div class="source-item-box pt-21">
                  <div class="label">发布服务器权限</div>

                  <img class="icon-forbid" src="@/assets/icon_allowed.png" />
                </div>
                <div class="source-item-box pt-20">
                  <div class="label">
                    发布项目权限
                                       <el-tooltip
                        placement="bottom"
                        :enterable="true"
                        popper-class="custom-tooltip"
                      >
                        <div slot="content" class="custom-tooltip-inner">
                          首发项目：1024元/个；<br />第二个项目：819.2元/个；<br />第三个项目及以上：614.4元/个。
                        </div>
                        <div class="remind-icon-box">
                          <img
                            class="icon-remind"
                            src="@/assets/icon_remind_red.png"
                          />
                        </div>
                      </el-tooltip>
                  </div>
                  <img class="icon-forbid" src="@/assets/icon_allowed.png" />
                </div> -->
                <div class="source-item-box pt-24">
                  <div class="label">商务支持</div>
                  <!-- <div class="item-value">帮你去谈客户</div> -->
                  <img class="icon-forbid" src="@/assets/icon_allowed.png" />
                </div>
                <div class="source-item-box">
                  <div class="label">技术支持</div>
                  <!-- <div class="item-value">帮你搞定复杂对接</div> -->
                  <img class="icon-forbid" src="@/assets/icon_allowed.png" />
                </div>
                <div class="source-item-box">
                  <div class="label">Ui支持</div>
                  <!-- <div class="item-value">帮你搞定设计</div> -->
                  <img class="icon-forbid" src="@/assets/icon_allowed.png" />
                </div>
              </div>
              <div class="productsource-title-box">
                <img
                  class="icon_exploit"
                  src="@/assets/icon_product_white.png"
                />
                <div>产品资源</div>
              </div>
              <div class="source-items-box source-items-box-product">
                <div class="source-item-box">
                  <div class="label">独自开开发工具包下载次数</div>
                  <div class="count">不限</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
    <!-- <DialogCustomFeedback ref="dialogCustomFeedback"></DialogCustomFeedback> -->
    <ButtonFeedback></ButtonFeedback>
    <DialogRecharge ref="dialogRecharge"></DialogRecharge>
  </div>
</template>

<script>
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ButtonFeedback from "@/components/ButtonFeedback";
import DialogRecharge from "@/components/dialog/Recharge";
import pageCommon from "@/utils/pagecommon";
import goodsApi from "@/api/goods";
import lodash from "lodash";
export default {
  name: "MemberIntroduce",
  components: {
    Nav,
    Footer,
    ButtonFeedback,
    DialogRecharge,
  },
  data() {
    return {
      price: 0,
    };
  },
  computed: {
    systemUser: function () {
      let _this = this;
      let systemUser = _this.$store.state.systemUser;
      return systemUser;
    },
    userInfo: function () {
      let _this = this;
      let userInfo = _this.$store.state.user;
      return userInfo;
    },
    userShopInfo: function () {
      let _this = this;
      let userShopInfo = _this.$store.state.userShopInfo;
      return userShopInfo;
    },
  },
  mounted() {
    let _this = this;
    _this.$store.dispatch("acNavIndex", 3);
    _this.getGoodsInfo();
  },
  methods: {
    getGoodsInfo: function () {
      let _this = this;
      let requestData = {
        isloading: true,
      };
      pageCommon.apiRequestCommon(goodsApi, "showGoodsInfo", requestData).then(
        (res) => {
          if (
            res &&
            res.public_goods_list &&
            res.public_goods_list.length > 0
          ) {
            let goodsInfo = res.public_goods_list[0];
            //3个月打9折，6个月打8折，12个月5折
            let price =
              goodsInfo.publicGoodsSupply4Shop.new_price_4_shop_retail;
            _this.price = price;
          } else {
          }
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this
              .$confirm("登录已失效, 请重新登录", "登录失效", {
                type: "warning",
                showCancelButton: false,
              })
              .then(() => {
                _this.$router.push({ path: "/login" });
              });
          }
        }
      );
    },
    handleUpgrade: function () {
      let _this = this;
      console.log(_this.userInfo)
      if (!_this.userInfo || _this.userInfo.id_public_user_info === 92) {
        _this.$message.warning("您未登录");
        _this.$router.push("/login");
        return;
      }
      _this.$refs.dialogRecharge.handleShow();
    },
    handleToRegister: function () {
      let _this = this;
      if (_this.userInfo) {
        _this.$message.warning("你已注册");
        return;
      }
      _this.$router.push("/register");
    },
    copyLink(){
      window.open('https://global-application-001.downline.cn/www.duzikai.com/goods_image/duzikai_written_examination_certification_20230213.zip');
    }
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/common.less";
.memberintroduce {
  overflow: hidden;
  .memberintroduce-box {
    width: 100%;
    color: #ffffff;
    font-size: 30px;
    overflow: hidden;

    .memberintroduce-inner {
      min-width: 1200px;
      padding-top: 80px;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
      box-sizing: border-box;
      .title {
        width: 100%;
        // font-size: 40px;
        // font-family: "SourceHanSansCN";
        // color: rgb(34, 34, 34);
        // font-weight: bold;
        // line-height: 0.5;
        text-align: center;

        font-size: 40px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
      }
      .subtitle {
        width: 100%;
        // font-size: 20px;
        // font-family: "SourceHanSansCN";
        // color: rgb(153, 153, 153);
        // line-height: 1;
        text-align: center;
        margin-top: 25px;

        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #999999;
        line-height: 23px;
      }
      img {
        width: 100%;
        height: 100%;
        vertical-align: top;
      }
      .banner-box {
        position: relative;
        width: 100%;
        height: 200px;
        box-sizing: border-box;
        background: url(~@/assets/bg_mc_introduce.jpg) no-repeat center bottom
          #07060b;
        background-size: 100% 200px;
        font-family: Source Han Sans CN;

        text-align: center;
        .banner-text {
          position: relative;
          width: 100%;
          font-size: 40px;
          color: #ffffff;
          line-height: 40px;
          padding-top: 48px;
          box-sizing: border-box;
          font-weight: bold;
          letter-spacing: 10px;
        }
        .banner-sub-text {
          position: relative;
          width: 303px;
          font-size: 18px;
          color: #d0d0d0;
          line-height: 26px;
          margin: 29px auto 0;
          // margin-top: 29px;
        }
        .swiper-wrapper {
          position: relative;
          width: 100%;
        }
        img {
          display: block;
          width: auto;
          height: 100%;
          margin: 0 auto;
        }
      }

      .introduce-items-box {
        position: relative;
        width: 100%;
        min-width: 1200px;
        padding-top: 88px;
        padding-bottom: 88px;
        box-sizing: border-box;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .introduce-item-box {
          position: relative;
          width: 480px;
          height: 1059px;
          background: #ffffff;
          box-shadow: 0px 15px 50px 0px rgba(92, 92, 92, 0.15);
          border-radius: 8px;
          margin-right: 100px;
          box-sizing: border-box;
          .introduce-item-icon {
            position: absolute;
            width: 158px;
            height: 158px;
            top: 10px;
            right: 0px;
          }
          &:last-child {
            margin-right: 0;
          }

          .introducemain-box {
            position: relative;
            width: 380px;
            margin: 0 auto;
            box-sizing: border-box;
            text-align: left;
            .introduce-name {
              position: relative;
              font-size: 32px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #222222;
              line-height: 32px;
              padding-top: 60px;
            }
            .introduce-price {
              position: relative;
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #999999;
              line-height: 20px;
              margin-top: 41px;
              box-sizing: border-box;
              .price-cont {
                font-size: 36px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #222222;
                line-height: 36px;
                padding-right: 10px;
              }
            }
            .button-box {
              position: relative;
              height: 196px;
              text-align: center;
              .custom-button {
                position: relative;
                width: 224px;
                height: 46px;
                line-height: 46px;
                text-align: center;
                font-size: 18px;
                font-family: Alibaba PuHuiTi;
                font-weight: bold;
                margin: 70px auto 0;
              }
              .btn-regnow {
                // color: #ec4040;
              }
            }
            .devsource-title-box,
            .productsource-title-box {
              position: relative;
              width: 100%;
              padding-bottom: 20px;
              border-bottom: 1px solid #d0d0d0;
              box-sizing: border-box;
              display: flex;
              display: -webkit-flex;
              flex-direction: row;
              align-items: center;

              font-size: 22px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #222222;
              line-height: 22px;
              .icon_exploit {
                position: relative;
                width: 24px;
                height: 23px;
                margin-right: 9px;
              }
              &.notbutton {
                margin-top: 70px;
              }
            }
            .source-items-box {
              position: relative;
              width: 100%;
              height: 356px;
              display: flex;
              display: -webkit-flex;
              flex-direction: column;
              justify-content: space-between;
              margin-top: 40px;

              .source-item-box {
                position: relative;
                width: 100%;
                display: flex;
                display: -webkit-flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                // padding-top: 30px;
                box-sizing: border-box;

                font-size: 18px;
                font-family: Source Han Sans CN;
                // font-weight: bold;
                color: #222222;
                line-height: 20px;

                &:first-child {
                  // padding-top: 40px;
                }
                &.pt-20 {
                  // padding-top: 20px;
                }
                &.pt-21 {
                  // padding-top: 21px;
                }
                &.pt-24 {
                  // padding-top: 24px;
                }
                &.pt-25 {
                  // padding-top: 25px;
                }
                .icon-forbid,
                .icon-allowed {
                  position: relative;
                  width: 28px;
                  height: 28px;
                }
                .label {
                  position: relative;
                  display: flex;
                  display: -webkit-flex;
                  flex-direction: row;
                  align-items: center;
                  &.cursorpointer {
                    cursor: pointer;
                  }
                  .remind-icon-box {
                    position: relative;
                    width: 18px;
                    height: 18px;
                    margin-left: 8px;
                    cursor: pointer;
                    .icon-remind {
                      position: relative;
                      width: 100%;
                      height: 100%;
                      margin-left: 0;
                    }
                  }
                  .icon-remind {
                    position: relative;
                    width: 18px;
                    height: 18px;
                    margin-left: 8px;
                  }
                }
              }
              &.source-items-box-product {
                height: auto;
                .source-item-box {
                  margin-top: 30px;
                  &:first-child {
                    margin-top: 0;
                  }
                }
              }
            }
            .productsource-title-box {
              margin-top: 60px;
            }
          }
          &.professional {
            color: #ffffff;
            background: linear-gradient(45deg, #080808 0%, #2d2d2d 99%);
            box-shadow: 0px 15px 50px 0px rgba(92, 92, 92, 0.15);
            .first-year-box {
              position: absolute;
              width: 180px;
              height: 40px;
              background: #ec4040;
              border-radius: 4px;
              box-sizing: border-box;
              top: -20px;
              left: 50%;
              transform: translate(-50%, 0);
              -webkit-transform: translate(-50%, 0);
              display: flex;
              display: -webkit-flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              font-size: 20px;
              font-family: Alibaba PuHuiTi;
              font-weight: bold;
              color: #ffffff;
              line-height: 20px;
              .remind-icon-box {
                position: relative;
                width: 18px;
                height: 18px;
                margin-left: 10px;
                cursor: pointer;
                .remind-icon {
                  position: relative;
                  width: 18px;
                  height: 18px;
                  cursor: pointer;
                }
              }
            }
            .introducemain-box {
              .introduce-name {
                color: #ffffff;
              }
              .introduce-price {
                color: #ffffff;
                .price-cont {
                  color: #ec4040;
                }
              }
              .button-box {
                .btn-upgrade {
                  color: #ffffff;
                }
              }
              .devsource-title-box,
              .productsource-title-box {
                color: #ffffff;
                border-bottom: 1px solid #ffffff;
              }
              .productsource-title-box {
                margin-top: 60px;
              }
              .source-items-box {
                color: #ffffff;
                .source-item-box {
                  color: #ffffff;
                  .item-value {
                    color: #ec4040;
                  }
                }
              }
            }
          }
        }
      }
      .case-title-box {
        position: relative;
        margin-top: 120px;
      }
      .case-options-box {
        position: relative;
        margin-top: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        .case-options-item {
          position: relative;
          border-radius: 4px;
          background-color: rgb(246, 246, 246);
          width: 240px;
          height: 130px;
          margin-left: 70px;

          font-size: 20px;
          line-height: 20px;
          font-family: "SourceHanSansCN";
          color: rgb(102, 102, 102);
          font-weight: bold;
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          .icon-box {
            width: 46px;
            height: 46px;
            margin-top: 22px;
            margin-bottom: 22px;
            &.icon-deal {
              background: url("../assets/icon_pingtai_unselect.png");
            }
            &.icon-manage {
              background: url("../assets/icon_yewumanage_unselect.png");
            }
            &.icon-apply {
              background: url("../assets/icon_yewuyy_unselect.png");
            }
            &.icon-retail {
              background: url("../assets/icon_retail_unselected.png");
            }
            &.icon-channel {
              background: url("../assets/icon_channel_unselected.png");
            }
          }
          // .icon {
          //   margin-top: 20px;
          // }
          // .icon-deal {
          //   width: 44px;
          //   height: 44px;
          // }
          // .icon-manage {
          //   width: 40px;
          //   height: 40px;
          // }
          // .icon-apply {
          //   width: 40px;
          //   height: 45px;
          // }
          .text {
            //             margin-top: 20px;
            //             width: 99px;
            // height: 20px;
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #222222;
            line-height: 20px;
          }
          &:first-child {
            margin-left: 0;
          }
          &.active {
            .text {
              color: rgb(34, 34, 34);
            }
            &::after {
              position: absolute;
              content: "";
              background: red;

              width: 100%;
              height: 4px;
              border-radius: 4px;
              bottom: 0;
            }
            .icon-box {
              &.icon-deal {
                background: url("../assets/icon_pingtai_selected.png");
              }
              &.icon-manage {
                background: url("../assets/icon_yewumanage_selected.png");
              }
              &.icon-apply {
                background: url("../assets/icon_yewuyy_select.png");
              }
              &.icon-retail {
                background: url("../assets/icon_retail_selected.png");
              }
              &.icon-channel {
                background: url("../assets/icon_channel_selected.png");
              }
            }
          }
        }
      }
    }
  }
}
</style>
